import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { forkJoin, Subscription } from 'rxjs';
import { Abteil } from './gruppe-tier-abteil-filter';

@Component({
    selector: 'kiene-gruppe-tier-abteil-filter',
    templateUrl: './gruppe-tier-abteil-filter.component.html',
    styleUrls: ['./gruppe-tier-abteil-filter.component.scss'],
})
export class GruppeTierAbteilFilterComponent implements OnInit, OnDestroy, OnChanges {
    abteileSubscription: Subscription;
    isLoading = true;
    label = 'Lädt...';

    @Input('gruppeId') selectedGruppeId: number;
    @Input() gruppeIds: number[] = [];
    @Input('abteile') abteile: Abteil[] = [];
    @Input('hideOnEmptyList') hideOnEmptyList = false;

    @Output('selectedAbteile') selectedAbteile: EventEmitter<Abteil[]> = new EventEmitter<Abteil[]>();
    selectedAbteilCtrl: UntypedFormControl = new UntypedFormControl(null);
    abteileFuerGruppe: Abteil[] = [];

    constructor(
        private readonly messageService: MessageService,
        private readonly stammdatenService: StammdatenService,
    ) {}

    ngOnDestroy(): void {
        this.abteileSubscription?.unsubscribe();
    }

    ngOnInit(): void {
        this.selectedAbteilCtrl.disable();
        this.loadAbteileFuerGruppe();

        this.selectedAbteilCtrl.setValue(this.abteile);

        this.selectedAbteilCtrl.valueChanges.subscribe((value: Abteil[]) => {
            this.selectedAbteile.emit(value);
        });
    }

    ngOnChanges() {
        this.loadAbteileFuerGruppe();
    }

    resetAbteilCtrl($event: MouseEvent) {
        $event.stopPropagation();
        this.selectedAbteilCtrl.setValue(undefined);
    }

    loadAbteileFuerGruppe() {
        const targetGroupIds =
            (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0).length > 0
                ? (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0)
                : this.selectedGruppeId
                  ? [Number(this.selectedGruppeId)]
                  : [];
        if (targetGroupIds.length > 0) {
            this.isLoading = true;
            this.abteileSubscription?.unsubscribe();
            const requests = targetGroupIds.map(gruppeId => this.stammdatenService.ladeAbteile(gruppeId));
            this.abteileSubscription = forkJoin(requests).subscribe({
                next: result => {
                    this.selectedAbteilCtrl.enable();
                    this.isLoading = false;
                    const byAbteil = new Map<string, Abteil>();
                    for (const res of result || []) {
                        for (const abteil of res?.records || []) {
                            const key = String(abteil?.abteil || '').trim();
                            if (!key || byAbteil.has(key)) {
                                continue;
                            }
                            byAbteil.set(key, abteil);
                        }
                    }
                    this.abteileFuerGruppe = Array.from(byAbteil.values());

                    if (this.abteileFuerGruppe.length === 0) {
                        this.label = 'keine Abteile';
                        this.selectedAbteilCtrl.disable();
                    } else {
                        this.label = 'Abteil';
                    }
                },
                error: err => {
                    this.isLoading = false;
                    this.messageService.errorMessage('Fehler beim Laden der Abteile', err);
                },
            });
        }
    }

    compareAbteil(a: Abteil, b: Abteil) {
        return a && b && a.abteil === b.abteil;
    }
}
